import React from 'react'
// components
import PositionsAPI from 'containers/Positions/layers/API/index'
import Positions from 'components/PageComponents/Settings/Positions/index'

const PositionsContainer: React.FC = () => {
  return (
    <PositionsAPI>
      <Positions />
    </PositionsAPI>
  )
}

export default PositionsContainer
